import type { PropsOf } from '@emotion/react';
import type { DatePicker } from '@innovationdepartment/proxima-ui';
import { useAdAccountStore } from 'stores';
import type { MetaAdAccount } from 'types/stores/ad-account-store';
import FacebookTableSearchFilterView from './FacebookTableSearchFilter.View';

type FacebookTableSearchFilterProps = {
  metaAdAccount: MetaAdAccount | null;
  onAdAccountChange: (adAccountId: string) => void;
  dateRange: PropsOf<typeof DatePicker>['dateRange'];
  onDateRangeChange: PropsOf<typeof DatePicker>['onDateRangeSelect'];
};
const FacebookTableSearchFilter: React.FC<FacebookTableSearchFilterProps> = props => {
  const { metaAdAccountsList } = useAdAccountStore();

  const formattedAdAccounts = metaAdAccountsList.map(account => ({
    label: account.name,
    value: account.adAccountId
  }));

  return <FacebookTableSearchFilterView {...props} adAccounts={formattedAdAccounts} />;
};

export default FacebookTableSearchFilter;
